function App() {
  return (
    <div className="container max-w-sm mx-auto">
      ✔︎
    </div>
  );
}

export default App;
